import React from "react"
//import BlackBg from "../black-bg"
import HeroContent from "./hero-content"
import ScrollAnimation from "react-animate-on-scroll"
import HeroImgDesktop from "./essentials-img-desktop"
import HeroImgMobile from "./essentials-img-mobile"
import EssentialsPageStyle from "./essentials-page.module.scss"

const Hero = () => (
    <div className={EssentialsPageStyle.heroDiv}>
        {/*<BlackBg /> */}
        <ScrollAnimation className="fadeIn" animateOnce={true} duration={2}>
            <HeroImgDesktop className={EssentialsPageStyle.heroImgDesktop} />
            <HeroImgMobile className={EssentialsPageStyle.heroImgDesktop} />
        </ScrollAnimation>
        <HeroContent />
       
    </div>
)

export default Hero